"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  dangerouslySetInnerHTML: {
    __html: "<path d=\"M9.017 11h5.966c-.086-2.544-.497-4.794-1.094-6.436-.34-.932-.719-1.616-1.09-2.048-.369-.428-.64-.513-.792-.516h-.014c-.153.003-.423.088-.792.516-.371.432-.75 1.116-1.09 2.048C9.514 6.206 9.103 8.456 9.017 11zM14.983 13c-.086 2.544-.497 4.794-1.094 6.436-.34.932-.719 1.616-1.09 2.048-.374.435-.648.516-.799.516-.151 0-.425-.081-.799-.516-.371-.432-.75-1.116-1.09-2.048-.597-1.642-1.008-3.892-1.094-6.436h5.966zM16.984 13h4.967a10.009 10.009 0 01-6.776 8.485c.219-.42.416-.878.593-1.365.69-1.897 1.13-4.387 1.216-7.12zM21.95 11h-4.966c-.086-2.733-.526-5.223-1.216-7.12a11.418 11.418 0 00-.593-1.365A10.009 10.009 0 0121.951 11zM7.016 11H2.049a10.009 10.009 0 016.776-8.485c-.219.42-.416.878-.593 1.365-.69 1.897-1.13 4.387-1.216 7.12zM7.016 13H2.049a10.009 10.009 0 006.776 8.485c-.219-.42-.416-.878-.593-1.365-.69-1.897-1.13-4.387-1.216-7.12z\" fill=\"#000\"></path>"
  },
  viewBox: "0 0 24 24",
  fill: "none"
};
exports["default"] = _default;